import { makeStyles } from '@material-ui/styles';
import Modal from 'common/components/modal';
import { CREATE_ORDER_NOTE, UPDATE_ORDER_NOTE } from './queries';
import { useMutation } from '@apollo/client';
import { Row, message, Input } from 'antd';
import React from 'react';
import generatePath from '~settings/routing';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const useActionFieldStyles = makeStyles(theme => ({
  wrapper: {
    '& .ant-modal-header': {
      paddingLeft: 32,
      paddingRight: 32,
    },

    '& .ant-modal-body': {
      padding: '0 32px',
    },

    '& .ant-form-item-label': {
      lineHeight: '22px !important',
      color: theme.colors.titleColor,
      marginBottom: 8,
    },

    '& .optional-label': {
      color: theme.colors.captionColor,
    },
  },
}));

const AddNotesActionField = ({ bookingId, record }) => {
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const classes = useActionFieldStyles();

  return (
    <Row
      className={classes.row}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <button
        className="accept-modal__btn"
        onClick={() => {
          setOpen(true);
        }}
      >
        Add Note
      </button>
      <NotesDialog
        open={open}
        setOpen={setOpen}
        bookingId={bookingId}
        refetchData={() => {
          message.success(
            <div style={{ display: 'inline-flex' }}>
              <div>Your note is successfully added.</div>
              <div
                style={{
                  color: '#38B2A6',
                  marginLeft: '8px',
                  fontSize: '14px',
                  lineHeight: '22px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  history.push(
                    generatePath('orders.lead_details', {
                      id: record.referenceId,
                    }),
                  );
                }}
              >
                Go to Check
              </div>
            </div>,
          );
        }}
      />
    </Row>
  );
};
const { TextArea } = Input;
const NotesDialog = ({ open, setOpen, noteId, note, bookingId, model, refetchData }) => {
  const [textAreaValue, setTextAreaValue] = React.useState(note);
  const classes = useActionFieldStyles();
  const [createOrderNote, { loading: createOrderNoteLoading }] = useMutation(CREATE_ORDER_NOTE, {
    variables: { input: { orderId: bookingId, note: textAreaValue } },
    onCompleted: () => {
      refetchData && refetchData();
      setTextAreaValue('');
      setOpen(false);
    },
    onError: e => {
      message.error(e.toString());
    },
  });
  React.useEffect(() => {
    setTextAreaValue(note);
  }, [setTextAreaValue, note]);

  const [updateOrderNote, { loading: updateOrderNoteLoading }] = useMutation(UPDATE_ORDER_NOTE, {
    variables: { input: { id: noteId, note: textAreaValue } },
    onCompleted: () => {
      refetchData && refetchData();
      setTextAreaValue('');
      setOpen(false);
    },
    onError: e => {
      message.error(e.toString());
    },
  });

  const textAreaOnchange = e => {
    setTextAreaValue(e.currentTarget.value);
  };
  return (
    <Modal
      width={446}
      visible={open}
      title={(model === 'EDIT' ? 'Edit' : 'Add') + ' Note'}
      okText={'Confirm'}
      wrapClassName={classes.wrapper}
      onCancel={() => {
        setOpen(false);
        setTextAreaValue('');
      }}
      onOk={() => {
        if (model === 'EDIT') {
          updateOrderNote();
        } else {
          createOrderNote();
        }
      }}
      okButtonProps={{
        disabled: !textAreaValue,
        loading: createOrderNoteLoading || updateOrderNoteLoading,
      }}
      destroyOnClose={true}
    >
      <div>Note:</div>
      <div style={{ marginBottom: '32px', marginTop: '8px' }}>
        <TextArea rows={5} maxLength={500} value={textAreaValue} onChange={textAreaOnchange} />

        <div className="limit-number">{textAreaValue?.length ?? 0}/500</div>
      </div>
    </Modal>
  );
};
export { NotesDialog };
export default AddNotesActionField;
